import { render, staticRenderFns } from "./ImportAndSale.vue?vue&type=template&id=53b7b948&"
import script from "./ImportAndSale.vue?vue&type=script&lang=js&"
export * from "./ImportAndSale.vue?vue&type=script&lang=js&"
import style0 from "./ImportAndSale.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports